<template>
    <rkm-area
        title="Integrações de Aplicativos"
        type="fieldset"
    >
        <rkm-row>
            <rkm-form-checkbox v-model="data.model.habilitaIntegracaoConectasusCidadao">
                Habilitar ConectaSUS Cidadão
                <rkm-icon
                    icon="info"
                    color="secondary"
                    class="infor"
                    small
                    v-rkm-popover.hover.left="{
                        html: true,
                        content: 'Quando ativado, permite disponibilizar e sincronizar vagas configuradas na Jornada para o App do Cidadão. Quando desativado, o sistema oculta os campos do App e não envia vagas, mesmo que estejam configuradas.'
                    }"
                />
            </rkm-form-checkbox>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    props: {
        data: {required: true, type: Object},
    },
}
</script>
	<style scoped>
    .infor {
        color: #acacac;
        height: 15px;
        width: 15px !important;
        border-radius: 31px;
        padding: 3px;
        border: 1px solid #c2c2c2;
        vertical-align: middle;
        margin-left: 4px;
    }
</style>
